import React, { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Heading from 'LuxKit/Typography/Heading'
import MarkdownRender from 'LuxKit/MarkdownRender'
import LargeContentToggle from 'components/Common/LargeContentToggle'

const Root = styled.div`
  padding-bottom: ${rem(16)};
  ${mediaQueryUp.tablet} {
    padding-bottom: ${rem(24)};
  }
`

const SectionHeader = styled.div`
  padding: ${rem(16)} 0;
  ${mediaQueryUp.tablet} {
    padding: ${rem(24)} 0;
  }
`

interface Props {
  inclusion: App.Tours.V2OfferInclusion
}

function TourV2UniqueInclusionSection(props: Props) {
  const { inclusion } = props

  return (
    <Root>
      <SectionHeader>
        <Heading variant="heading5">{inclusion.title}</Heading>
      </SectionHeader>
      <LargeContentToggle maxHeight={85} showMoreText="Read more" showLessText="Read less">
        <MarkdownRender content={inclusion.body} />
      </LargeContentToggle>
    </Root>
  )
}

export default memo(TourV2UniqueInclusionSection)
